<template>
  <section>
    <LpHeader />

    <main>
      <slot />
    </main>

    <LpFooter />
  </section>
</template>

<script>
import LpHeader from '@/components/lp/LpHeader.vue';
import LpFooter from '@/components/lp/LpFooter.vue';

export default {
  name: 'LpLayout',
  components: {
    LpHeader,
    LpFooter,
  },
  metaInfo: {
    title: 'Adbc株式会社 採用LP',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    ],
    link: [
      { rel: 'stylesheet', href: 'style.css' },
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
        crossorigin: true,
      },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap',
      },
    ],
  },
};
</script>
